import { Column } from "./types"

const DESIGN_FRAME_WIDTH_PX = 1920

export const getColumnWidth = <T>({ width, minWidth }: Column<T>) => {
   const columnWidth = `${((width ?? 0) / DESIGN_FRAME_WIDTH_PX) * 100}vw`
   return minWidth ? `max(${minWidth}px, ${columnWidth})` : columnWidth
}
